module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-57x57-053c2b7a023a66e6ef87f5a9bbf14696.png";